import type { CrossSellPhase1Category } from "@dransay/api/models";

export { CROSS_SELL_PHASE1_CATEGORIES } from "@dransay/api/models";

export type CrossSellCategory = CrossSellPhase1Category;

export const CROSS_SELL_CATEGORY_ALL = "all" as const;

export type CrossSellCategoryFilter =
	| typeof CROSS_SELL_CATEGORY_ALL
	| CrossSellCategory;

export type CrossSellCategorySlug =
	| "vaporizers"
	| "510er-batteries"
	| "preparation-and-grinders"
	| "accessories";

/**
 * Values are stable filter keys, not display text -- never show them raw;
 * translate via `crossSell.categories.${CROSS_SELL_CATEGORY_SLUGS[category]}`.
 * They are also sent as `cross_sell_category` on Product Viewed (OTC-324), so
 * renaming one changes Data's reports.
 */
export const CROSS_SELL_CATEGORY_SLUGS: Record<
	CrossSellCategory,
	CrossSellCategorySlug
> = {
	Vaporizers: "vaporizers",
	"510er Batteries": "510er-batteries",
	"Preparation & Grinders": "preparation-and-grinders",
	Accessories: "accessories",
};

/**
 * Subcategory keys are seeded by stock-service-api's
 * Migration20260814140000_seed_otc_subcategories, itself taken from the PRD.
 * medical_device is included under Vaporizers because RN's own menu doc files
 * Volcano Medic 2 under Desktop Vaporizers and Mighty+ Medic under Portable
 * Vaporizers. accessory, maintenance_kit and wear_and_tear_kit all file under
 * Accessories -- the general-purpose bucket for anything that isn't a
 * vaporizer or a prep/grinder tool.
 */
const CROSS_SELL_CATEGORY_BY_SUBCATEGORY: Record<string, CrossSellCategory> = {
	portable_vaporizer: "Vaporizers",
	desktop_vaporizer: "Vaporizers",
	medical_device: "Vaporizers",
	"510_cartridge_battery": "510er Batteries",
	grinder: "Preparation & Grinders",
	accessory: "Accessories",
	maintenance_kit: "Accessories",
	wear_and_tear_kit: "Accessories",
};

/** Unmapped subcategories return null, leaving the product under "All" only. */
export function resolveCrossSellCategory(
	subcategory: string,
): CrossSellCategory | null {
	return CROSS_SELL_CATEGORY_BY_SUBCATEGORY[subcategory] ?? null;
}
